import { render, staticRenderFns } from "./PotentialBidderDialog.vue?vue&type=template&id=1cb84102"
import script from "./PotentialBidderDialog.vue?vue&type=script&lang=js"
export * from "./PotentialBidderDialog.vue?vue&type=script&lang=js"
import style0 from "./PotentialBidderDialog.vue?vue&type=style&index=0&id=1cb84102&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports